import { faFacebookF } from "@fortawesome/free-brands-svg-icons/faFacebookF"
import { faFacebookMessenger } from "@fortawesome/free-brands-svg-icons/faFacebookMessenger"
import { faPinterest } from "@fortawesome/free-brands-svg-icons/faPinterest"
import { faXTwitter } from "@fortawesome/free-brands-svg-icons/faXTwitter"
import { faShareNodes } from "@jewlr/pro-solid-svg-icons/faShareNodes"
import PropTypes from "prop-types"
import { useEffect, useState } from "react"
import { connect } from "react-redux"

import Button from "components/ui/button"
import FontAwesomeIcon from "components/ui/font-awesome-icon"
import Media from "components/ui/media"
import { generateSourceURL, shorten_url } from "helpers/analytics-helpers"
import { isTestMode } from "helpers/application"
import socialShare from "helpers/social-share"
import WebShareApi from "helpers/web-share-api"

const SocialIcon = (props) => (
  <Button className="text-primary text-22 items-center" text {...props} />
)

const ShareType = (props) => (
  <p
    className="text-primary tablet:block tablet:text-14 ml-8 hidden"
    {...props}
  />
)

const InternalSocialShare = ({
  doNativeShare,
  prefStore,
  socialShare,
  wizardLoading,
}) => {
  const [nativeShare, setNativeShare] = useState(true)
  const disabled = !prefStore || wizardLoading

  useEffect(() => {
    if (!WebShareApi.shareIsSupported()) {
      setNativeShare(false)
    }
  }, [])

  return (
    <>
      {nativeShare && (
        <Media className="flex-1" lessThan="desktop">
          <Button
            className="text-primary mx-auto flex"
            disabled={disabled}
            onClick={(e) => doNativeShare(e)}
            underline
            variant="tertiary"
          >
            Share
            <FontAwesomeIcon className="text-12 ml-8" icon={faShareNodes} />
          </Button>
        </Media>
      )}
      <Media
        className="flex justify-around px-40 py-24"
        greaterThanOrEqual="desktop"
      >
        <SocialIcon
          aria-label="Share on Facebook"
          disabled={disabled}
          onClick={(e) => socialShare("Facebook", e)}
        >
          <FontAwesomeIcon icon={faFacebookF} />
          <ShareType>Share</ShareType>
        </SocialIcon>
        <SocialIcon
          aria-label="Post on X"
          disabled={disabled}
          onClick={(e) => socialShare("Twitter", e)}
        >
          <FontAwesomeIcon icon={faXTwitter} />
          <ShareType>Post</ShareType>
        </SocialIcon>
        <SocialIcon
          aria-label="Pin it on Pinterest"
          disabled={disabled}
          onClick={(e) => socialShare("Pinterest", e)}
        >
          <FontAwesomeIcon icon={faPinterest} />
          <ShareType>Pin it</ShareType>
        </SocialIcon>
        <SocialIcon
          aria-label="Send via Messenger"
          disabled={disabled}
          onClick={(e) => socialShare("Messenger", e)}
        >
          <FontAwesomeIcon icon={faFacebookMessenger} />
          <ShareType>Send</ShareType>
        </SocialIcon>
      </Media>
    </>
  )
}

// Genearte product default params url
const getParams = (state) => {
  let qs = "" //'style_code=' + style_code;
  let choices = state.choices
  let choice_keys = Object.keys(choices)
  for (let i = 0; i < choice_keys.length; i++) {
    qs +=
      "&" +
      choice_keys[i] +
      "=" +
      encodeURIComponent(choices[choice_keys[i]].value || "")
  }
  return qs
}

const mapStateToProps = (state) => {
  return {
    defaultParams: getParams(state),
    prefStore: state.wizardUI.prefStore,
    state,
    wizardLoading: state.wizard.loading,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}

const gtmEvent = (state, share_type) => {
  // GTM record event
  if (!isTestMode) {
    dataLayer.push({
      currencyCode: state.wizard.price_and_promo.currency_code,
      event: "product-shared",
      sharedMethod: share_type,
      styleCode: state.choices.style_code?.value,
    })
  }
}

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  const { state, defaultParams, prefStore } = stateProps

  return {
    ...ownProps,
    ...stateProps,
    ...dispatchProps,
    doNativeShare: (e) => {
      e.preventDefault()

      if (!prefStore) {
        return
      }

      gtmEvent(state, "Native")

      const share_url = generateSourceURL(
        `${state.wizard.shareUrl}?${defaultParams}`,
        "native"
      )

      WebShareApi.triggerWebShare(
        "Jewlr",
        `Check this out from Jewlr! ${state.wizard.title}`,
        share_url,
        (err) => {
          if (err) {
            console.log(err)
          }
        }
      )
    },
    socialShare: async (share_type, e) => {
      let popup = null
      if (share_type == "Twitter" || share_type == "Pinterest") {
        popup = window.open("", "_blank", "status=1,width=650,height=550")
      }
      e.preventDefault()

      if (!state.wizardUI.prefStore) {
        return
      }

      gtmEvent(state, share_type)

      // Shorten share url
      let share_url = `${state.wizard.shareUrl}?${defaultParams}`
      share_url = await shorten_url(generateSourceURL(share_url, share_type))

      let images = {
        ...state.wizard.images,
        ...state.previewImage.data.images,
      }
      let imageUrl = images["share_view"].src
      let share_properties = {
        clickLabel: state.choices.style_code?.value,
        clickType: `Product ${share_type} Share`,
        imageUrl: imageUrl,
        message: `Check this out from Jewlr! ${state.wizard.title}`,
        popup,
        url: share_url,
      }

      socialShare({ share_type: share_type, ...share_properties })
    },
  }
}

InternalSocialShare.propTypes = {
  doNativeShare: PropTypes.func.isRequired,
  prefStore: PropTypes.bool,
  socialShare: PropTypes.func.isRequired,
  wizardLoading: PropTypes.string,
}

const SocialShare = connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(InternalSocialShare)

export default SocialShare
